import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import useDataAttributes from "theme/components/helpers/useDataAttributes";

/**
 * BackgroundImageViaCss is to implement an image via in the css
 *
 * @type {React.FC<BackgroundImageViaCssProps>}
 * */
const BackgroundImageViaCss = ({ src, children, className, ...props }) => {
  const dataAttributes = useDataAttributes(props);

  return (
    <div
      className={classNames("background-image-via-css", className)}
      style={src ? { backgroundImage: `url(${src})` } : undefined}
      {...dataAttributes}
    >
      {/*
       * This allows the image to be downloaded at the time when the HTML is loaded instead of adding it
       * to the end of the queue, see: https://buildawesomewebsites.com/html-img-vs-css-background-image
       */}
      {src && <img src={src} alt="" hidden aria-hidden="true" />}
      {children}
    </div>
  );
};

/** @typedef {PropTypes.InferProps<typeof propTypes>} BackgroundImageViaCssProps */
const propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
};

BackgroundImageViaCss.propTypes = propTypes;

export default BackgroundImageViaCss;
